export default __webpack_public_path__ + "static/v2_adrian_bw-f85c8c3a1450fbc8ade3d6e9659862b7.jpg";